var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "questionnaireQuestion", class: _vm.classes },
    [
      _c(
        "label",
        {
          staticClass: "questionnaireQuestionLabel",
          attrs: { for: _vm.template.id },
        },
        [
          _c(
            "span",
            {
              staticClass: "questionnaireQuestionLabelOrd",
              class: _vm.classes,
            },
            [_vm._v(_vm._s(_vm.template.ord) + ".")]
          ),
          _c("span", [_vm._v(_vm._s(_vm.template.name))]),
        ]
      ),
      _c("input", {
        staticClass: "questionnaireQuestionInput",
        attrs: {
          id: _vm.template.id,
          readonly: "readonly",
          name: _vm.template.id,
        },
        domProps: { value: _vm.value },
      }),
      _c("tooltip", {
        attrs: {
          ord: _vm.template.ord,
          title: _vm.template.name,
          description: _vm.template.description,
          required: !!_vm.isRequired,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }